/*------------------------------------------------
// File Name:PDM_BodyCheck_DaoRu.js
// File Description:PDM_BodyCheck_DaoRu store方法
// Author:zxl
// Create Time:2023/05/12 18:28:47
//------------------------------------------------*/

import {
    GetPDM_BodyCheck_DaoRuList,
    GetPDM_BodyCheck_DaoRuListByPage,
    GetPDM_BodyCheck_DaoRuEntity,
    CreatePDM_BodyCheck_DaoRuEntity,
    UpdatePDM_BodyCheck_DaoRuEntity,
    DeletePDM_BodyCheck_DaoRuEntity,
} from '@/api/pdm/bodycheckDaoru'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmBodycheckDaoru = {
    namespaced: true,
    state: {
        PdmBodycheckDaoruList: [],
        PdmBodycheckDaoruListLoading: false,
        PdmBodycheckDaoruEntity: null,
        PdmBodycheckDaoruShowDlg: false,
    },
    mutations: {
        setPdmBodycheckDaoruList(state, dataList) {
            state.PdmBodycheckDaoruList = [...dataList]
        },
        setPdmBodycheckDaoruListLoading(state, visible) {
            state.PdmBodycheckDaoruListLoading = visible
        },
        setPdmBodycheckDaoruShowDlg(state, visible) {
            state.PdmBodycheckDaoruShowDlg = visible
        },
        setPdmBodycheckDaoruEntity(state, entity) {
            state.PdmBodycheckDaoruEntity = entity
        },
    },
    actions: {
        //创建对象
        actCreatePdmBodycheckDaoru({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_BodyCheck_DaoRuEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckDaoruEntity', res.Data)
                        commit('setPdmBodycheckDaoruShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载对象
        actGetPdmBodycheckDaoruEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckDaoruListLoading', true)
                GetPDM_BodyCheck_DaoRuEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckDaoruEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckDaoruListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载列表
        actGetPdmBodycheckDaoruList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckDaoruListLoading', true)
                GetPDM_BodyCheck_DaoRuList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckDaoruList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckDaoruListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载列表
        actGetPdmBodycheckDaoruListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBodycheckDaoruListLoading', true)
                GetPDM_BodyCheck_DaoRuListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckDaoruList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBodycheckDaoruListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存信息
        actUpdatePdmBodycheckDaoru({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_BodyCheck_DaoRuEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBodycheckDaoruShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_DaoRu
        actEditPdmBodycheckDaoruData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmBodycheckDaoruID : entity.PdmBodycheckDaoruID
                }
                GetPDM_BodyCheck_DaoRuEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmBodycheckDaoruEntity', res.Data)
                        commit('setPdmBodycheckDaoruShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BodyCheck_DaoRu ,传对象过来
        actEditPdmBodycheckDaoru({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmBodycheckDaoruEntity', entity)
                commit('setPdmBodycheckDaoruShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_BodyCheck_DaoRu
        actDeletePdmBodycheckDaoru({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前？").onOk(() => {
                    DeletePDM_BodyCheck_DaoRuEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmBodycheckDaoruShowDlg', false)
                           
                            msg.success("删除成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除失败，原因:" + res.Message)
                            //msg.success("删除失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


